(function($, undefined) {

	'use strict';
	var sitekey = 'YOUR_SITE_KEY';
	
	const USERNAME_SEPARATOR = "#%#";
	
	/* RECAPTCHA UTIL FUNCTION */
	/**
	 * Render recaptchas dynamically.
	 * @param   btn         An element referencing the button or a string 
	 *                      referencing the Id of the element.
	 * @param   callback    A function to be called after recaptcha has 
	 *                      completed its check. The function is passed back
	 *                      the recaptcha response and the form element.
	 * @param   validate    (optional) A boolean to know if a form needs to be 
	 *                      validated using the formValidator in com/form.js.
	 * @param   form        (optional) A jQuery object reference the form to be
	 *                      validated using formValidator in com/form.js.
	 */

	var recaptcha = function(btn, callback, validate, form) {
		if(btn && window.grecaptcha) {
			grecaptcha.render(btn, {
				'sitekey' : sitekey,
				'callback' : function(response) {
					var formValidator = Fw.component.models().form.validateForm;
					var validated = true;
					if(validate) {
						validated = false;	
						formValidator(form);
						if(!form.hasClass('has-error')) {
							validated = true;
						}
					}
					
					if(validated) {
						fn(response, form);
					} else {
						grecaptcha.reset();
					}
				},
				'badge': 'inline'
			});
		} else if(btn && !window.grecaptcha) {
			setTimeout(function() {
				recaptcha(btn, callback, validate, form);
			}, 250);
		}
	};
	
	
	var saveSessionVariable = function(key, value, reload) {
		var params = {
			key: key
		};
		if (value) {
			params.value = value;
		}
		$.ajax({
			url: "/action/sessionVariables",
			method: "post",
			data: params,
			complete: function(response) {
				console.log(response.responseText);
				
				if (reload) {
					location.reload();
				}
			}
		});
	};
	
	var deletePerson = function(id, callback = () => {}) {
		var params = {
			ajax: true,
			id: id,
			delete: true
		};
		$.ajax({
			url: "/action/updatePerson",
			method: "post",
			data: params,
			complete: function(response) {
				callback(response.responseText);
			}
		});
	};
	
	var deleteStudent = function(id, callback = () => {}) {
		var params = {
			id: id,
			delete: true
		};
		$.ajax({
			url: "/action/csrsAjax",
			method: "post",
			data: params,
			complete: function(response) {
				callback(response.responseText);
			}
		});
	};
	
	var deleteGenData = function(id, callback = () => {}) {
		var action = '/action/manageGenData';
		var params = {
			ajax: true,
			delete: true,
			id: id
		};
		$.ajax({
			url: action,
			data: params,
			method: "post",
			complete: function(response) {
				callback(response.responseText);
			}
		});
	};
	
	var getMaxFromArray = function(array) {
		var max = 0;
		var index = 0;
		if (array.length > 0) {
			max = array[0];	
			for (let i = 1; i < array.length; i++) {
				if (array[i] > max) {
					max = array[i];
					index = i;
				}
			}
		}
		return {
			value: max,
			index: index
		};
	};
	
	var getGenDataJson = function(id, callback) {
		$.ajax({
			url: "/action/fetchGenData",
			method: "get",
			data: {
				ajax: true,
				json: true,
				id: id
			},
			complete: function(response) {
				callback(response.responseText);
			}
		});
	};
	
	var getGenData = function(id, callback) {
		$.ajax({
			url: "/action/fetchGenData",
			method: "get",
			data: {
				ajax: true,
				id: id
			},
			complete: function(response) {
				callback(response.responseText);
			}
		});
	};
	
	var fetchGenDatasJson = function(fields, callback) {
		var params = {
			ajax: true,
			json: true
		};
		Object.assign(params, fields);
		$.ajax({
			url: "/action/fetchGenData",
			method: "get",
			data: params,
			complete: function(response) {
				callback(response.responseText);
			}
		});
	};
	
	var loadLexiqueText = function(text, callback) {
		$.ajax({
			url: "/action/csrsAjax",
			method: "post",
			data: {
				text: text
			},
			complete: function(response) {
				callback(response.responseText);	
			}
		});
	};
	
	var isElementInScrollView = function(el) {
	    if (typeof jQuery === "function" && el instanceof jQuery) {
	        el = el[0];
	    }
	    var rect = el.getBoundingClientRect();
	    return (
	        rect.top <= $(window).height()
	    );
	};
	
	var getUsernameSeparator = function() {
		return USERNAME_SEPARATOR;
	};
	
	var isTouchDevice = function() {
		var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
		  var mq = function(query) {
		    return window.matchMedia(query).matches;
		  }

		  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		    return true;
		  }

		  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
		  // https://git.io/vznFH
		  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
		  return mq(query);	
	};
	
	var utils = Fw.component.export('utils', {
		recaptcha: recaptcha,
		saveSessionVariable: saveSessionVariable,
		deletePerson: deletePerson,
		deleteStudent: deleteStudent,
		deleteGenData: deleteGenData,
		getMaxFromArray: getMaxFromArray,
		getGenDataJson: getGenDataJson,
		getGenData: getGenData,
		loadLexiqueText: loadLexiqueText,
		isElementInScrollView: isElementInScrollView,
		fetchGenDatasJson: fetchGenDatasJson,
		getUsernameSeparator: getUsernameSeparator,
		isTouchDevice: isTouchDevice
	});

})(jQuery);
